// TODO: alphabetize move names. I'm trying to implement this on a low-quality laptop under time pressure, so I haven't bothered doing so.
export const FormatsData: import('../../../sim/dex-species').ModdedSpeciesFormatsDataTable = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		tier: "RU",
		doublesTier: "DUU",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		tier: "PUBL",
		doublesTier: "DUU",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		tier: "UU",
		doublesTier: "DUU",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		tier: "PU",
		doublesTier: "DUU",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		tier: "PU",
		doublesTier: "DUU",
	},
	beedrillmega: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "NFE",
	},
	pidgeot: {
		tier: "PU",
		doublesTier: "DUU",
	},
	pidgeotmega: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rattata: {
		tier: "LC",
	},
	raticate: {
		tier: "PU",
		doublesTier: "DUU",
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		tier: "PU",
		doublesTier: "DUU",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		tier: "PU",
		doublesTier: "DUU",
	},
	pichu: {
		tier: "LC",
	},
	pikachu: {
		tier: "NFE",
	},
	raichu: {
		tier: "PUBL",
		doublesTier: "DOU",
	},
	sandshrew: {
		tier: "LC",
	},
	sandslash: {
		tier: "PU",
		doublesTier: "DUU",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		tier: "RU",
		doublesTier: "DUU",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		tier: "OU",
		doublesTier: "DUU",
	},
	cleffa: {
		tier: "LC",
	},
	clefairy: {
		tier: "NFE",
	},
	clefable: {
		tier: "OU",
		doublesTier: "DUU",
	},
	vulpix: {
		tier: "NFE",
	},
	ninetales: {
		tier: "PU",
		doublesTier: "DUU",
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		tier: "PU",
		doublesTier: "DUU",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "NFE",
	},
	crobat: {
		tier: "UU",
		doublesTier: "DUU",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NFE",
	},
	vileplume: {
		tier: "RU",
		doublesTier: "DUU",
	},
	bellossom: {
		tier: "NU",
		doublesTier: "DOU",
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		tier: "PU",
		doublesTier: "DUU",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		tier: "RUBL",
		doublesTier: "DUU",
	},
	diglett: {
		tier: "LC",
	},
	dugtrio: {
		tier: "PU",
		doublesTier: "DUU",
	},
	meowth: {
		tier: "LC",
	},
	persian: {
		tier: "PU",
		doublesTier: "DUU",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		tier: "PU",
		doublesTier: "DUU",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		tier: "RU",
		doublesTier: "DUU",
	},
	growlithe: {
		tier: "LC",
	},
	arcanine: {
		tier: "RU",
		doublesTier: "DOU",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NFE",
	},
	poliwrath: {
		tier: "NU",
		doublesTier: "DUU",
	},
	politoed: {
		tier: "PU",
		doublesTier: "DOU",
	},
	abra: {
		tier: "LC",
	},
	kadabra: {
		tier: "NU",
	},
	alakazam: {
		tier: "OU",
		doublesTier: "DUU",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "NFE",
	},
	machamp: {
		tier: "UU",
		doublesTier: "DUU",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "NFE",
	},
	victreebel: {
		tier: "NU",
		doublesTier: "DUU",
	},
	tentacool: {
		tier: "LC",
	},
	tentacruel: {
		tier: "RU",
		doublesTier: "DUU",
	},
	geodude: {
		tier: "LC",
	},
	graveler: {
		tier: "NFE",
	},
	golem: {
		tier: "PU",
		doublesTier: "DUU",
	},
	ponyta: {
		tier: "LC",
	},
	rapidash: {
		tier: "PU",
		doublesTier: "DUU",
	},
	slowpoke: {
		tier: "LC",
	},
	slowbro: {
		tier: "RU",
		doublesTier: "DUU",
	},
	slowking: {
		tier: "RU",
		doublesTier: "DUU",
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		tier: "PUBL",
		doublesTier: "NFE",
	},
	magnezone: {
		tier: "OU",
		doublesTier: "DUU",
	},
	farfetchd: {
		tier: "PU",
		doublesTier: "DUU",
	},
	doduo: {
		tier: "LC",
	},
	dodrio: {
		tier: "PU",
		doublesTier: "DUU",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		tier: "PU",
		doublesTier: "DUU",
	},
	grimer: {
		tier: "LC",
	},
	muk: {
		tier: "PU",
		doublesTier: "DUU",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		tier: "UU",
		doublesTier: "DUU",
	},
	gastly: {
		tier: "LC",
	},
	haunter: {
		tier: "NUBL",
		doublesTier: "NFE",
	},
	gengar: {
		tier: "Uber",
		doublesTier: "DUU",
	},
	onix: {
		tier: "LC",
	},
	steelix: {
		tier: "RU",
		doublesTier: "DUU",
	},
	drowzee: {
		tier: "LC",
	},
	hypno: {
		tier: "PU",
		doublesTier: "DUU",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		tier: "PUBL",
		doublesTier: "DUU",
	},
	voltorb: {
		tier: "LC",
	},
	electrode: {
		tier: "PU",
		doublesTier: "DUU",
	},
	exeggcute: {
		tier: "LC",
	},
	exeggutor: {
		tier: "NUBL",
		doublesTier: "DUU",
	},
	cubone: {
		tier: "LC",
	},
	marowak: {
		tier: "PU",
		doublesTier: "DUU",
	},
	tyrogue: {
		tier: "LC",
	},
	hitmonlee: {
		tier: "NU",
		doublesTier: "DUU",
	},
	hitmonchan: {
		tier: "RU",
		doublesTier: "DUU",
	},
	hitmontop: {
		tier: "RU",
		doublesTier: "DOU",
	},
	lickitung: {
		tier: "LC",
	},
	lickilicky: {
		tier: "PU",
		doublesTier: "DUU",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		tier: "NU",
		doublesTier: "DUU",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		tier: "PU",
		doublesTier: "NFE",
	},
	rhyperior: {
		tier: "RU",
		doublesTier: "DUU",
	},
	happiny: {
		tier: "LC",
	},
	chansey: {
		tier: "RU",
	},
	blissey: {
		tier: "OU",
		doublesTier: "DUU",
	},
	tangela: {
		tier: "NFE",
	},
	tangrowth: {
		tier: "OU",
		doublesTier: "DUU",
	},
	kangaskhan: {
		tier: "NU",
		doublesTier: "DUU",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "NFE",
	},
	kingdra: {
		tier: "RUBL",
		doublesTier: "DOU",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		tier: "PU",
		doublesTier: "DUU",
	},
	staryu: {
		tier: "LC",
	},
	starmie: {
		tier: "OU",
		doublesTier: "DUU",
	},
	mimejr: {
		tier: "LC",
	},
	mrmime: {
		tier: "NU",
		doublesTier: "DUU",
	},
	scyther: {
		tier: "NU",
		doublesTier: "NFE",
	},
	scizor: {
		tier: "OU",
		doublesTier: "DOU",
	},
	smoochum: {
		tier: "LC",
	},
	jynx: {
		tier: "NUBL",
		doublesTier: "DUU",
	},
	elekid: {
		tier: "LC",
	},
	electabuzz: {
		tier: "NFE",
	},
	electivire: {
		tier: "NU",
		doublesTier: "DUU",
	},
	magby: {
		tier: "LC",
	},
	magmar: {
		tier: "NFE",
	},
	magmortar: {
		tier: "RU",
		doublesTier: "DUU",
	},
	pinsir: {
		tier: "PUBL",
		doublesTier: "DUU",
	},
	tauros: {
		tier: "RU",
		doublesTier: "DUU",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		tier: "UU",
		doublesTier: "DOU",
	},
	lapras: {
		tier: "PU",
		doublesTier: "DUU",
	},
	ditto: {
		tier: "PU",
		doublesTier: "DUU",
	},
	eevee: {
		tier: "LC",
	},
	vaporeon: {
		tier: "RU",
		doublesTier: "DUU",
	},
	jolteon: {
		tier: "PU",
		doublesTier: "DUU",
	},
	flareon: {
		tier: "PU",
		doublesTier: "DUU",
	},
	espeon: {
		tier: "RU",
		doublesTier: "DUU",
	},
	umbreon: {
		tier: "UU",
		doublesTier: "DUU",
	},
	leafeon: {
		tier: "NU",
		doublesTier: "DUU",
	},
	glaceon: {
		tier: "NU",
		doublesTier: "DUU",
	},
	porygon: {
		tier: "LC",
	},
	porygon2: {
		tier: "NU",
	},
	porygonz: {
		tier: "UU",
		doublesTier: "DUU",
	},
	omanyte: {
		tier: "LC",
	},
	omastar: {
		tier: "RU",
		doublesTier: "DUU",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		tier: "RU",
		doublesTier: "DUU",
	},
	aerodactyl: {
		tier: "NUBL",
		doublesTier: "DUU",
	},
	munchlax: {
		tier: "LC",
	},
	snorlax: {
		tier: "UU",
		doublesTier: "DUU",
	},
	articuno: {
		tier: "PU",
		doublesTier: "DUU",
	},
	zapdos: {
		tier: "UU",
		doublesTier: "DOU",
	},
	moltres: {
		tier: "RU",
		doublesTier: "DUU",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NFE",
	},
	dragonite: {
		tier: "OU",
		doublesTier: "DUU",
	},
	mewtwo: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	mew: {
		tier: "OU",
		doublesTier: "DUU",
	},
	chikorita: {
		tier: "LC",
	},
	bayleef: {
		tier: "NFE",
	},
	meganium: {
		tier: "PU",
		doublesTier: "DUU",
	},
	cyndaquil: {
		tier: "LC",
	},
	quilava: {
		tier: "NFE",
	},
	typhlosion: {
		tier: "NU",
		doublesTier: "DUU",
	},
	totodile: {
		tier: "LC",
	},
	croconaw: {
		tier: "NFE",
	},
	feraligatr: {
		tier: "OU",
		doublesTier: "DUU",
	},
	sentret: {
		tier: "LC",
	},
	furret: {
		tier: "PU",
		doublesTier: "DUU",
	},
	hoothoot: {
		tier: "LC",
	},
	noctowl: {
		tier: "PU",
		doublesTier: "DUU",
	},
	ledyba: {
		tier: "LC",
	},
	ledian: {
		tier: "PU",
		doublesTier: "DUU",
	},
	spinarak: {
		tier: "LC",
	},
	ariados: {
		tier: "PU",
		doublesTier: "DUU",
	},
	chinchou: {
		tier: "LC",
	},
	lanturn: {
		tier: "NU",
		doublesTier: "DUU",
	},
	togepi: {
		tier: "LC",
	},
	togetic: {
		tier: "NFE",
	},
	togekiss: {
		tier: "OU",
		doublesTier: "DOU",
	},
	natu: {
		tier: "LC",
	},
	xatu: {
		tier: "RU",
		doublesTier: "DUU",
	},
	mareep: {
		tier: "LC",
	},
	flaaffy: {
		tier: "NFE",
	},
	ampharos: {
		tier: "PU",
		doublesTier: "DUU",
	},
	azurill: {
		tier: "LC",
	},
	marill: {
		tier: "NFE",
	},
	azumarill: {
		tier: "OU",
		doublesTier: "DOU",
	},
	bonsly: {
		tier: "LC",
	},
	sudowoodo: {
		tier: "PU",
		doublesTier: "DUU",
	},
	hoppip: {
		tier: "LC",
	},
	skiploom: {
		tier: "NFE",
	},
	jumpluff: {
		tier: "PU",
		doublesTier: "DUU",
	},
	aipom: {
		tier: "LC",
	},
	ambipom: {
		tier: "RU",
		doublesTier: "DUU",
	},
	sunkern: {
		tier: "LC",
	},
	sunflora: {
		tier: "PU",
		doublesTier: "DUU",
	},
	yanma: {
		tier: "NFE",
	},
	yanmega: {
		tier: "UU",
		doublesTier: "DUU",
	},
	wooper: {
		tier: "LC",
	},
	quagsire: {
		tier: "RU",
		doublesTier: "DUU",
	},
	murkrow: {
		tier: "NFE",
	},
	honchkrow: {
		tier: "NU",
		doublesTier: "DUU",
	},
	misdreavus: {
		tier: "NFE",
	},
	mismagius: {
		tier: "UU",
		doublesTier: "DUU",
	},
	unown: {
		tier: "PU",
		doublesTier: "DUU",
	},
	wynaut: {
		tier: "LC",
	},
	wobbuffet: {
		tier: "PU",
		doublesTier: "DUU",
	},
	girafarig: {
		tier: "PU",
		doublesTier: "DUU",
	},
	pineco: {
		tier: "LC",
	},
	forretress: {
		tier: "UU",
		doublesTier: "DUU",
	},
	dunsparce: {
		tier: "PU",
		doublesTier: "DUU",
	},
	gligar: {
		tier: "NU",
		doublesTier: "NFE",
	},
	gliscor: {
		tier: "OU",
		doublesTier: "DUU",
	},
	snubbull: {
		tier: "LC",
	},
	granbull: {
		tier: "NU",
		doublesTier: "DUU",
	},
	qwilfish: {
		tier: "NU",
		doublesTier: "DUU",
	},
	shuckle: {
		tier: "PU",
		doublesTier: "DUU",
	},
	heracross: {
		tier: "UUBL",
		doublesTier: "DUU",
	},
	sneasel: {
		tier: "NU",
		doublesTier: "NFE",
	},
	weavile: {
		tier: "OU",
		doublesTier: "DUU",
	},
	teddiursa: {
		tier: "LC",
	},
	ursaring: {
		tier: "NU",
		doublesTier: "DUU",
	},
	slugma: {
		tier: "LC",
	},
	magcargo: {
		tier: "PU",
		doublesTier: "DUU",
	},
	swinub: {
		tier: "LC",
	},
	piloswine: {
		tier: "NFE",
	},
	mamoswine: {
		tier: "OU",
		doublesTier: "DOU",
	},
	corsola: {
		tier: "PU",
		doublesTier: "DUU",
	},
	remoraid: {
		tier: "LC",
	},
	octillery: {
		tier: "PU",
		doublesTier: "DUU",
	},
	delibird: {
		tier: "PU",
		doublesTier: "DUU",
	},
	mantyke: {
		tier: "LC",
	},
	mantine: {
		tier: "RU",
		doublesTier: "DUU",
	},
	skarmory: {
		tier: "OU",
		doublesTier: "DUU",
	},
	houndour: {
		tier: "LC",
	},
	houndoom: {
		tier: "RU",
		doublesTier: "DUU",
	},
	phanpy: {
		tier: "LC",
	},
	donphan: {
		tier: "UU",
		doublesTier: "DUU",
	},
	stantler: {
		tier: "PU",
		doublesTier: "DUU",
	},
	smeargle: {
		tier: "NU",
		doublesTier: "DUber",
	},
	miltank: {
		tier: "NU",
		doublesTier: "DUU",
	},
	raikou: {
		tier: "UU",
		doublesTier: "DOU",
	},
	entei: {
		tier: "UU",
		doublesTier: "DOU",
	},
	suicune: {
		tier: "OU",
		doublesTier: "DOU",
	},
	larvitar: {
		tier: "LC",
	},
	pupitar: {
		tier: "NFE",
	},
	tyranitar: {
		tier: "UU",
		doublesTier: "DOU",
	},
	lugia: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	hooh: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	celebi: {
		tier: "OU",
		doublesTier: "DOU",
	},
	treecko: {
		tier: "LC",
	},
	grovyle: {
		tier: "NFE",
	},
	sceptile: {
		tier: "RU",
		doublesTier: "DUU",
	},
	torchic: {
		tier: "LC",
	},
	combusken: {
		tier: "NFE",
	},
	blaziken: {
		tier: "Uber",
		doublesTier: "DUU",
	},
	mudkip: {
		tier: "LC",
	},
	marshtomp: {
		tier: "NFE",
	},
	swampert: {
		tier: "UU",
		doublesTier: "DUU",
	},
	poochyena: {
		tier: "LC",
	},
	mightyena: {
		tier: "PU",
		doublesTier: "DUU",
	},
	zigzagoon: {
		tier: "LC",
	},
	linoone: {
		tier: "NUBL",
		doublesTier: "DUU",
	},
	wurmple: {
		tier: "LC",
	},
	silcoon: {
		tier: "NFE",
	},
	beautifly: {
		tier: "PU",
		doublesTier: "DUU",
	},
	cascoon: {
		tier: "NFE",
	},
	dustox: {
		tier: "PU",
		doublesTier: "DUU",
	},
	lotad: {
		tier: "LC",
	},
	lombre: {
		tier: "NFE",
	},
	ludicolo: {
		tier: "NU",
		doublesTier: "DOU",
	},
	seedot: {
		tier: "LC",
	},
	nuzleaf: {
		tier: "NFE",
	},
	shiftry: {
		tier: "PU",
		doublesTier: "DUU",
	},
	taillow: {
		tier: "LC",
	},
	swellow: {
		tier: "RU",
		doublesTier: "DUU",
	},
	wingull: {
		tier: "LC",
	},
	pelipper: {
		tier: "PU",
		doublesTier: "DOU",
	},
	ralts: {
		tier: "LC",
	},
	kirlia: {
		tier: "NFE",
	},
	gardevoir: {
		tier: "UU",
		doublesTier: "DOU",
	},
	gallade: {
		tier: "RU",
		doublesTier: "DUU",
	},
	surskit: {
		tier: "LC",
	},
	masquerain: {
		tier: "PU",
		doublesTier: "DUU",
	},
	shroomish: {
		tier: "LC",
	},
	breloom: {
		tier: "OU",
		doublesTier: "DOU",
	},
	slakoth: {
		tier: "LC",
	},
	vigoroth: {
		tier: "NFE",
	},
	slaking: {
		tier: "PU",
		doublesTier: "DUU",
	},
	nincada: {
		tier: "LC",
	},
	ninjask: {
		tier: "PU",
		doublesTier: "DUU",
	},
	shedinja: {
		tier: "PU",
		doublesTier: "DUU",
	},
	whismur: {
		tier: "LC",
	},
	loudred: {
		tier: "NFE",
	},
	exploud: {
		tier: "RU",
		doublesTier: "DUU",
	},
	makuhita: {
		tier: "LC",
	},
	hariyama: {
		tier: "RU",
		doublesTier: "DOU",
	},
	nosepass: {
		tier: "LC",
	},
	probopass: {
		tier: "PU",
		doublesTier: "DUU",
	},
	skitty: {
		tier: "LC",
	},
	delcatty: {
		tier: "PU",
		doublesTier: "DUU",
	},
	sableye: {
		tier: "RU",
		doublesTier: "DOU",
	},
	mawile: {
		tier: "PU",
		doublesTier: "DUU",
	},
	aron: {
		tier: "LC",
	},
	lairon: {
		tier: "NFE",
	},
	aggron: {
		tier: "NU",
		doublesTier: "DUU",
	},
	meditite: {
		tier: "NFE",
	},
	medicham: {
		tier: "RU",
		doublesTier: "DUU",
	},
	electrike: {
		tier: "LC",
	},
	manectric: {
		tier: "PU",
		doublesTier: "DUU",
	},
	plusle: {
		tier: "PU",
		doublesTier: "DUU",
	},
	minun: {
		tier: "PU",
		doublesTier: "DUU",
	},
	volbeat: {
		tier: "PU",
		doublesTier: "DUU",
	},
	illumise: {
		tier: "PU",
		doublesTier: "DUU",
	},
	budew: {
		tier: "LC",
	},
	roselia: {
		tier: "NFE",
	},
	roserade: {
		tier: "OU",
		doublesTier: "DUU",
	},
	gulpin: {
		tier: "LC",
	},
	swalot: {
		tier: "PU",
		doublesTier: "DUU",
	},
	carvanha: {
		tier: "LC",
	},
	sharpedo: {
		tier: "UU",
		doublesTier: "DUU",
	},
	wailmer: {
		tier: "LC",
	},
	wailord: {
		tier: "PU",
		doublesTier: "DUU",
	},
	numel: {
		tier: "LC",
	},
	camerupt: {
		tier: "PU",
		doublesTier: "DUU",
	},
	torkoal: {
		tier: "PU",
		doublesTier: "DOU",
	},
	spoink: {
		tier: "LC",
	},
	grumpig: {
		tier: "PUBL",
		doublesTier: "DUU",
	},
	spinda: {
		tier: "PU",
		doublesTier: "DUU",
	},
	trapinch: {
		tier: "LC",
	},
	vibrava: {
		tier: "NFE",
	},
	flygon: {
		tier: "UU",
		doublesTier: "DUU",
	},
	cacnea: {
		tier: "LC",
	},
	cacturne: {
		tier: "NU",
		doublesTier: "DUU",
	},
	swablu: {
		tier: "LC",
	},
	altaria: {
		tier: "PU",
		doublesTier: "DUU",
	},
	zangoose: {
		tier: "NUBL",
		doublesTier: "DUU",
	},
	seviper: {
		tier: "PU",
		doublesTier: "DUU",
	},
	lunatone: {
		tier: "PU",
		doublesTier: "DUU",
	},
	solrock: {
		tier: "PU",
		doublesTier: "DUU",
	},
	barboach: {
		tier: "LC",
	},
	whiscash: {
		tier: "NU",
		doublesTier: "DUU",
	},
	corphish: {
		tier: "LC",
	},
	crawdaunt: {
		tier: "OU",
		doublesTier: "DUU",
	},
	baltoy: {
		tier: "LC",
	},
	claydol: {
		tier: "NU",
		doublesTier: "DUU",
	},
	lileep: {
		tier: "LC",
	},
	cradily: {
		tier: "NU",
		doublesTier: "DOU",
	},
	anorith: {
		tier: "LC",
	},
	armaldo: {
		tier: "PU",
		doublesTier: "DUU",
	},
	feebas: {
		tier: "LC",
	},
	milotic: {
		tier: "OU",
		doublesTier: "DOU",
	},
	castform: {
		tier: "PU",
		doublesTier: "DUU",
	},
	castformsunny: {
	},
	castformrainy: {
	},
	castformsnowy: {
	},
	kecleon: {
		tier: "PU",
		doublesTier: "DUU",
	},
	shuppet: {
		tier: "LC",
	},
	banette: {
		tier: "PU",
		doublesTier: "DUU",
	},
	duskull: {
		tier: "LC",
	},
	dusclops: {
		tier: "NFE",
	},
	dusknoir: {
		tier: "NU",
		doublesTier: "DUU",
	},
	tropius: {
		tier: "PU",
		doublesTier: "DUU",
	},
	chingling: {
		tier: "LC",
	},
	chimecho: {
		tier: "PU",
		doublesTier: "DUU",
	},
	absol: {
		tier: "RUBL",
		doublesTier: "DUU",
	},
	snorunt: {
		tier: "LC",
	},
	glalie: {
		tier: "PU",
		doublesTier: "DUU",
	},
	froslass: {
		tier: "RU",
		doublesTier: "DUU",
	},
	spheal: {
		tier: "LC",
	},
	sealeo: {
		tier: "NFE",
	},
	walrein: {
		tier: "PU",
		doublesTier: "DUU",
	},
	clamperl: {
		tier: "LC",
	},
	huntail: {
		tier: "PUBL",
		doublesTier: "DUU",
	},
	gorebyss: {
		tier: "NU",
		doublesTier: "DUU",
	},
	relicanth: {
		tier: "PU",
		doublesTier: "DUU",
	},
	luvdisc: {
		tier: "PU",
		doublesTier: "DUU",
	},
	bagon: {
		tier: "LC",
	},
	shelgon: {
		tier: "NFE",
	},
	salamence: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	beldum: {
		tier: "LC",
	},
	metang: {
		tier: "NFE",
	},
	metagross: {
		tier: "UU",
		doublesTier: "DUU",
	},
	regirock: {
		tier: "NU",
		doublesTier: "DUU",
	},
	regice: {
		tier: "PU",
		doublesTier: "DUU",
	},
	registeel: {
		tier: "RU",
		doublesTier: "DUU",
	},
	latias: {
		tier: "OU",
		doublesTier: "DUU",
	},
	latios: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	kyogre: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	groudon: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	rayquaza: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	jirachi: {
		tier: "UU",
		doublesTier: "DUU",
	},
	deoxys: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	deoxysattack: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	deoxysdefense: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	deoxysspeed: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	turtwig: {
		tier: "LC",
	},
	grotle: {
		tier: "NFE",
	},
	torterra: {
		tier: "RU",
		doublesTier: "DUU",
	},
	chimchar: {
		tier: "LC",
	},
	monferno: {
		tier: "NFE",
	},
	infernape: {
		tier: "OU",
		doublesTier: "DOU",
	},
	piplup: {
		tier: "LC",
	},
	prinplup: {
		tier: "NFE",
	},
	empoleon: {
		tier: "UU",
		doublesTier: "DUU",
	},
	starly: {
		tier: "LC",
	},
	staravia: {
		tier: "NFE",
	},
	staraptor: {
		tier: "OU",
		doublesTier: "DUU",
	},
	bidoof: {
		tier: "LC",
	},
	bibarel: {
		tier: "NUBL",
		doublesTier: "DUU",
	},
	kricketot: {
		tier: "LC",
	},
	kricketune: {
		tier: "PU",
		doublesTier: "DUU",
	},
	shinx: {
		tier: "LC",
	},
	luxio: {
		tier: "NFE",
	},
	luxray: {
		tier: "PU",
		doublesTier: "DUU",
	},
	cranidos: {
		tier: "LC",
	},
	rampardos: {
		tier: "PU",
		doublesTier: "DUU",
	},
	shieldon: {
		tier: "LC",
	},
	bastiodon: {
		tier: "PU",
		doublesTier: "DUU",
	},
	burmy: {
		tier: "LC",
	},
	wormadam: {
		tier: "PU",
		doublesTier: "DUU",
	},
	wormadamsandy: {
		tier: "PU",
		doublesTier: "DUU",
	},
	wormadamtrash: {
		tier: "PU",
		doublesTier: "DUU",
	},
	mothim: {
		tier: "PU",
		doublesTier: "DUU",
	},
	combee: {
		tier: "LC",
	},
	vespiquen: {
		tier: "PU",
		doublesTier: "DUU",
	},
	pachirisu: {
		tier: "PU",
		doublesTier: "DUU",
	},
	buizel: {
		tier: "LC",
	},
	floatzel: {
		tier: "PU",
		doublesTier: "DUU",
	},
	cherubi: {
		tier: "LC",
	},
	cherrim: {
		tier: "PU",
		doublesTier: "DUU",
	},
	shellos: {
		tier: "LC",
	},
	gastrodon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	drifloon: {
		tier: "LC",
	},
	drifblim: {
		tier: "PUBL",
		doublesTier: "DUU",
	},
	buneary: {
		tier: "LC",
	},
	lopunny: {
		tier: "PU",
		doublesTier: "DUU",
	},
	glameow: {
		tier: "LC",
	},
	purugly: {
		tier: "PU",
		doublesTier: "DUU",
	},
	stunky: {
		tier: "LC",
	},
	skuntank: {
		tier: "NU",
		doublesTier: "DUU",
	},
	bronzor: {
		tier: "LC",
	},
	bronzong: {
		tier: "RU",
		doublesTier: "DOU",
	},
	chatot: {
		tier: "PUBL",
		doublesTier: "DUU",
	},
	spiritomb: {
		tier: "RU",
		doublesTier: "DUU",
	},
	gible: {
		tier: "LC",
	},
	gabite: {
		tier: "NFE",
	},
	garchomp: {
		tier: "OU",
		doublesTier: "DOU",
	},
	riolu: {
		tier: "LC",
	},
	lucario: {
		tier: "OU",
		doublesTier: "DUU",
	},
	hippopotas: {
		tier: "LC",
	},
	hippowdon: {
		tier: "UU",
		doublesTier: "DUU",
	},
	skorupi: {
		tier: "LC",
	},
	drapion: {
		tier: "UU",
		doublesTier: "DUU",
	},
	croagunk: {
		tier: "LC",
	},
	toxicroak: {
		tier: "NU",
		doublesTier: "DUU",
	},
	carnivine: {
		tier: "PU",
		doublesTier: "DUU",
	},
	finneon: {
		tier: "LC",
	},
	lumineon: {
		tier: "PU",
		doublesTier: "DUU",
	},
	snover: {
		tier: "LC",
	},
	abomasnow: {
		tier: "NU",
		doublesTier: "DOU",
	},
	rotom: {
		tier: "RU",
		doublesTier: "DUU",
	},
	rotomheat: {
		tier: "UU",
		doublesTier: "DUU",
	},
	rotomwash: {
		tier: "OU",
		doublesTier: "DOU",
	},
	rotomfrost: {
		tier: "PUBL",
		doublesTier: "DUU",
	},
	rotomfan: {
		tier: "PU",
		doublesTier: "DUU",
	},
	rotommow: {
		tier: "UU",
		doublesTier: "DUU",
	},
	uxie: {
		tier: "RU",
		doublesTier: "DUU",
	},
	mesprit: {
		tier: "RU",
		doublesTier: "DUU",
	},
	azelf: {
		tier: "OU",
		doublesTier: "DUU",
	},
	dialga: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	palkia: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	heatran: {
		tier: "OU",
		doublesTier: "DOU",
	},
	regigigas: {
		tier: "PU",
		doublesTier: "DUU",
	},
	giratina: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	giratinaorigin: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	cresselia: {
		tier: "UU",
		doublesTier: "DOU",
	},
	phione: {
		tier: "PU",
		doublesTier: "DUU",
	},
	manaphy: {
		tier: "Uber",
		doublesTier: "DUU",
	},
	darkrai: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	shaymin: {
		tier: "UU",
		doublesTier: "DOU",
	},
	shayminsky: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceus: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	arceusbug: {
	},
	arceusdark: {
	},
	arceusdragon: {
	},
	arceuselectric: {
	},
	arceusfairy: {
	},
	arceusfighting: {
	},
	arceusfire: {
	},
	arceusflying: {
	},
	arceusghost: {
	},
	arceusgrass: {
	},
	arceusground: {
	},
	arceusice: {
	},
	arceuspoison: {
	},
	arceuspsychic: {
	},
	arceusrock: {
	},
	arceussteel: {
	},
	arceuswater: {
	},
	// Because it's marked as Unobtainable in the main file for some reason
	eternatuseternamax: {
		inherit: true,
		isNonstandard: "Past",
	},
};
